"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fix_1 = require("./fix");
/**
 *
 * Split the string with word separators
 * such as punctuation marks and spaces
 *
**/
function separate(input) {
    var splitted = input
        .replace(/([\s\(\)\[\]<>"'])/g, "\0$1\0")
        .replace(/([?;:,.!]+)(?=(\0|$|\s))/g, "\0$1\0")
        .split("\0");
    var fixed = fix_1.default(splitted);
    return fixed;
}
exports.separate = separate;
/**
 *
 * Join the resulting array into a string
 *
**/
function deSeparate(input) {
    return input.join("");
}
exports.deSeparate = deSeparate;



//////////////////
// WEBPACK FOOTER
// ../~/anchorme/dist-node/separate/separate.js
// module id = 688
// module chunks = 3